import io from 'socket.io-client';
import moment from 'moment';
import store from '../store';


class MySocket {
    constructor() {
        console.debug('Creating a socket.');
        this.socket = {
            connected: false,
        };

        this.options = {
            transports: ['websocket'],
        };

        this.events = {};
    }

    async connectSocket() {
        // eslint-disable-next-line no-restricted-globals
        let websocketOrigin;
        if (process.env.MIX_WEBSOCKET_ORIGIN) {
            websocketOrigin = process.env.MIX_WEBSOCKET_ORIGIN;
        } else {
            websocketOrigin = location.origin
        }

        console.log("setting websocket origin: ", websocketOrigin, location.origin)

        this.socket = await io(websocketOrigin, this.options);

        this.socket.on('server-debug', (data) => console.log(`Got a server debug message at ${moment().format()}:`,
            { data }));

        this.socket.on('connected', () => this.applyEvents('connected'));

        this.socket.on('connect', () => {
            console.log(`L31 Got connect at ${moment().format()}.`);

            if (store.state.authToken) {
                const auth = `${store.state.authToken.token_type} ${store.state.authToken.access_token}`;

                this.socket.emit(
                    'Authorization',
                    auth,
                );
            } else {
                console.warn('No token found in the store state.');
            }
        });

        this.socket.on('reconnect', () => {
            this.applyEvents('reconnect');
        });

        this.socket.on('newEmailsReceived', (data) => {
            store.commit('storeUserEmailNotification', data.message);
            store.commit(
                'storeUnreadMessagesCount',
                data.current_unread_messages_count,
            );
            this.applyEvents('NewEmails');
        });
    }

    /**
     * Attempts to apply any queued events, if present.
     */
    applyEvents(respondingTo = null, debug = true) {
        const events = Object.keys(this.events);

        if (debug) {
            const numberOfEvents = events.length;
            console.log(`Responding to ${respondingTo}, there are ${numberOfEvents} in the queue.`,
                {
                    eventKeys: Object.keys(this.events),
                });
        }

        events.forEach((event) => {
            const callbacks = this.events[event];
            callbacks.forEach((cb) => {
                this.socket.on(event, cb);
            });
        });

        this.events = {};
    }

    /**
     * Add an event listener.
     *
     * @param event
     * @param cb
     * @returns {Promise<void>}
     */
    async on(event, cb) {
        if (this.socket && this.socket.connected) {
            console.log('L65 - Calling this.socket.on with event:', event);

            this.socket.on(event, cb);
        } else {
            if (!this.socket) {
                console.log('Queuing event because "this.socket" is not a truthy value.');
            }
            if (!this.socket.connected) {
                console.log('Queueing event because "this.socket.connected" is not a truthy value.', {
                    connected: this.socket.connected,
                    socket: this.socket,
                });

                if (typeof this.socket.on === 'function') {
                    console.warn('Socket not connected but "this.socket.on" is a function.');
                    console.trace('L84');
                }
            } else {
                console.trace('Queueing event because of an unknown reason?', {socket: this.socket});
            }

            if (!this.events[event]) {
                this.events[event] = [];
            }

            this.events[event].push(cb);
        }
    }

    remove(event) {
        this.socket.removeListener(event);
    }

    disconnect() {
        if (!this.socket || !this.socket.disconnect) return;

        this.socket.disconnect();
    }

    isConnected() {
        return this.socket.connected;
    }
}

const instance = new MySocket();

export default instance;
